module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/02_shape-lg-c1291fc151f4547d3ac50f1b5cff54ca.png";